import { FormGroup, ModalWrapper, TextInput } from "carbon-components-react";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { useValidation, validateNotEmpty } from "../../utils/validation";

const defaultState = {
  account_number: "",
  first_name: "",
  last_name: "",
  email_address: "",
};

const validators = {
  account_number: [validateNotEmpty],
  first_name: [validateNotEmpty],
  last_name: [validateNotEmpty],
  email_address: [validateNotEmpty],
};

const CYCPaymentModal = ({ disabled = false, onSubmit = () => true }) => {
  const [form, setForm] = useState(defaultState);
  const [validation, invalid] = useValidation(form, validators);
  return (
    <ModalWrapper
      buttonTriggerText="Pay Now"
      disabled={disabled}
      handleSubmit={() => onSubmit(form)}
      id="cyc-payment-modal"
      modalHeading="Pay Now"
      passiveModal={false}
      preventCloseOnClickOutside={true}
      primaryButtonDisabled={disabled || invalid}
      primaryButtonText="Pay"
      secondaryButtonText="Cancel"
      shouldCloseAfterSubmit={true}
      shouldSubmitOnEnter={false}
      size="xs"
    >
      <FormGroup invalid={invalid} legendText="" message={false}>
        <TextInput
          id="cyc-accountnumber-input"
          invalid={
            Boolean(validation.account_number) && form.account_number !== ""
          }
          invalidText="A valid value is required"
          labelText="Account Number"
          light={true}
          type="text"
          value={form.account_number}
          onChange={(e) => setForm({ ...form, account_number: e.target.value })}
        />
        <TextInput
          id="cyc-firstname-input"
          invalid={Boolean(validation.first_name) && form.first_name !== ""}
          invalidText="A valid value is required"
          labelText="First Name"
          light={true}
          type="text"
          value={form.first_name}
          onChange={(e) => setForm({ ...form, first_name: e.target.value })}
        />
        <TextInput
          id="cyc-lastname-input"
          invalid={Boolean(validation.last_name) && form.last_name !== ""}
          invalidText="A valid value is required"
          labelText="Last Name"
          light={true}
          type="text"
          value={form.last_name}
          onChange={(e) => setForm({ ...form, last_name: e.target.value })}
        />
        <TextInput
          id="cyc-email-input"
          invalid={
            Boolean(validation.email_address) && form.email_address !== ""
          }
          invalidText="A valid value is required"
          labelText="Email"
          light={true}
          type="text"
          value={form.email_address}
          onChange={(e) => setForm({ ...form, email_address: e.target.value })}
        />
      </FormGroup>
    </ModalWrapper>
  );
};

CYCPaymentModal.propTypes = {
  disabled: PropTypes.bool,
  onSubmit: PropTypes.func,
};

export default CYCPaymentModal;
